import { ProfileFormInput } from "Types/employee";

export function useProfileFormInitialValues() {
  const initialValues: Partial<ProfileFormInput> = {
    country: 'MY',
    dob: '',
  }

  const getInitialValues = () => initialValues;

  return { getInitialValues };
}